<template>
<div class="main menus">

	<div class="list-view">

		<div class="sub-header">
		</div>

		<div v-if="showFilters" class="filters">
			<div class="title">Select which settings you want to edit...</div>
			<div :class="['filter-list-button-large', settingSet == 'RECEIPT'? 'active' : '']" @click="toggleSettings('RECEIPT')">
				<div class="label">Receipt</div>
				<div class="note">What to print on your receipts.</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'PAYMENTS'? 'active' : '']" @click="toggleSettings('PAYMENTS')">
				<div class="label">Payments</div>
				<div class="note">Additional POS payment settings.</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'UPCS'? 'active' : '']" @click="toggleSettings('UPCS')">
				<div class="label">UPCs & Notifications</div>
				<div class="note">Special UPCs and notifications for POS.</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'COMMISSIONS'? 'active' : '']" @click="toggleSettings('COMMISSIONS')">
				<div class="label">Commissions</div>
				<div class="note">Preferences for the comissions report.</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'REQUIRE_CUSTOMERS'? 'active' : '']" @click="toggleSettings('REQUIRE_CUSTOMERS')">
				<div class="label">Require Customer</div>
				<div class="note">Set departments / categories that require a customer.</div>
			</div>
			<div :class="['filter-list-button-large', settingSet == 'REQUIRED'? 'active' : '']" @click="toggleSettings('REQUIRED')">
				<div class="label">Required Info</div>
				<div class="note">Set customer info required at checkout.</div>
			</div>
		</div>

		<div class="detail no-sidebar no-sub-header" v-if="!loading">
			<h1>{{ settingTitles[settingSet] }}</h1>

			<div v-if="settingSet == 'RECEIPT'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>Receipt Logo</label>
					<div class="two-columns">
						<img v-if="settings.pos_store_logo_src" :src='settings.pos_store_logo_src' style="max-width: 300px;">
						<div v-else class="empty-list">No Logo Uploaded</div>
						<vue-dropzone @vdropzone-success="logoUploadSuccess" @vdropzone-error="logoUploadError" ref="logoDropzone" id="logo_dropzone" :options="logoDropzoneOptions"/>
					</div>
				</div>
				<div class="instruction">You can upload a version of your logo specifically for receipts.<br>We recommend a small black-and-white JPEG file.</div>
				<div class="settings-group">
					<label>Store Name</label>
					<input type="text" v-model="settings.pos_store_name">
				</div>
				<div class="instruction">Enter an optional store name if you don't want<br>your profile company name printed on your receipts.</div>
				<div class="settings-group">
					<label>Top Text</label>
					<textarea v-model="settings.pos_receipt_heading"></textarea>
				</div>
				<div class="instruction">Enter any message you'd like printed near the top of your receipts.</div>
				<div class="settings-group">
					<label>Bottom Text</label>
					<textarea v-model="settings.pos_receipt_text"></textarea>
				</div>
				<div class="instruction">Enter any message you'd like printed near the bottom of your receipts.</div>
				<div class="settings-group">
					<label class="full">Duplicate for Credit Card Transactions?</label>
					<label class="radio first">
						<input type="radio" v-model="settings.pos_duplicate_receipt" value="yes">
						<span><i class="fas fa-check-circle"></i>Yes</span>
					</label>
					<label class="radio last">
						<input type="radio" v-model="settings.pos_duplicate_receipt" value="no">
						<span><i class="fas fa-check-circle"></i>No</span>
					</label>
				</div>
				<div class="instruction">Sales involving a credit card normally print two reciept copies.</div>
			</div>

			<div v-if="settingSet == 'PAYMENTS'">
				<div class="two-columns settings-columns">
					<div class="settings-group">
						<label class="full">Do you take financing as a POS payment option?</label>
						<label class="radio first">
							<input type="radio" v-model="settings.pos_financing_available" value="1">
							<span><i class="fas fa-check-circle"></i>Yes</span>
						</label>
						<label class="radio last">
							<input type="radio" v-model="settings.pos_financing_available" value="">
							<span><i class="fas fa-check-circle"></i>No</span>
						</label>
					</div>
					<div class="instruction">When enabled, cashiers will see a Financing payment option in POS which takes a completed financing number.</div>
					<div class="settings-group">
						<label class="full">Do you take Auth Code from your credit card processor as a POS payment option?</label>
						<label class="radio first">
							<input type="radio" v-model="settings.pos_authcode_available" value="1">
							<span><i class="fas fa-check-circle"></i>Yes</span>
						</label>
						<label class="radio last">
							<input type="radio" v-model="settings.pos_authcode_available" value="">
							<span><i class="fas fa-check-circle"></i>No</span>
						</label>
					</div>
					<div class="instruction">When enabled, cashiers will see an Auth Code payment option in POS which takes a completed authorization number.</div>

					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.pos_disable_gift_cards">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Disable gift cards at <b>POS</b></span>
					</label>
					<div class="instruction">Gift cards payments will not be available at POS.<br>(Need to disable for Checkout? <router-link to="/website/checkout/payments">Use Checkout Settings</router-link>.)</div>

					<div>
						<label class="checkbox with-outside-label">
							<input type="checkbox" v-model="settings.pos_round_cash_payments">
							<span><i class="fas fa-check-circle"></i></span>
							<span class="label-text">Round cash payments</span>
						</label>
						<div class="one-two-columns" style="margin: 0 0 0 2.66em;">
							<div>
								Round direction: 
								<select v-model="settings.pos_round_cash_payments_direction" style="width: auto; display: inline-block; margin: 0 0.5em;">
									<option value="">Select...</option>
									<option value="up">Up</option>
									<option value="down">Down</option>
									<option value="average">Average</option>
								</select>
							</div>
							<div>
								Round to nearest:
								<select v-model="settings.pos_round_cash_payments_to" style="width: auto; display: inline-block; margin: 0 0.5em;">
									<option value="">Select...</option>
									<option value="0.05">$0.05</option>
									<option value="0.10">$0.10</option>
									<option value="0.25">$0.25</option>
									<option value="0.50">$0.50</option>
									<option value="1.00">$1.00</option>
								</select>
							</div>
						</div>
					</div>
					<div class="instruction">
						Round direction "average" means round up when decimal is 5 or greater, and round down when it is 4 or less.<br><br>
						For example, with "average" and round to nearest $0.05, $10.02 rounds to $10.00 and $10.17 rounds to $10.20.
					</div>
				</div>
			</div>
			<div v-if="settingSet == 'UPCS'" class="two-columns settings-columns">
				<div class="settings-group">
					<label class="full">Override UPC</label>
					<input type="text" class="half" v-model="settings.pos_override_upc">
					<label class="spaced">Default is {{ settings.pos_override_upc_default }}</label>
				</div>
				<div class="instruction">Scanning your override UPC in POS<br>will bring up the product override screen.</div>
				<div class="settings-group">
					<label class="full">Transfer UPC</label>
					<input type="text" class="half" v-model="settings.pos_transfer_upc" placeholder="">
					<label class="spaced">Default is {{ settings.pos_transfer_upc_default }}</label>
				</div>
				<div class="instruction">Scanning your transfer UPC in POS<br>will bring up the product transfer screen.</div>
				<!-- <div class="settings-group">
					<label class="full">Gunsmithing UPC</label>
					<input type="text" class="half" v-model="settings.pos_gunsmithing_upc" placeholder="">
					<label class="spaced">Default is 99997</label>
				</div>
				<div class="instruction">Scanning your gunsmithing UPC in POS<br>will bring up the gunsmithing screen.</div>
				<div class="settings-group">
					<label class="full">Tradein UPC</label>
					<input type="text" class="half" v-model="settings.pos_tradein_upc" placeholder="">
					<label class="spaced">Default is 99996</label>
				</div>
				<div class="instruction">Scanning your trade in UPC in POS<br>will bring up the trade in screen.</div> -->
				<div class="settings-group">
					<label>Completed Sale Notifications</label>
					<textarea v-model="settings.pos_notification_emails" style="height: 5em;"></textarea>
				</div>
				<div class="instruction">Enter one or more email addresses that will receive notification of POS orders.<br><br>If entering more than one, put each address on a separate line.</div>

			</div>

			<div v-if="settingSet == 'COMMISSIONS'" class="two-columns settings-columns">

				<div class="settings-group">
					<p>By default, the Cashier Commission Report includes sales and payments from all departments and categories.</p>
					<label>Limit the report to these departments and categories...</label>
					<div class="department_list">
						<div v-for="(item, index) in currentFilterList" class="department_list_item">
							<span>{{ item.description }}</span>
							<span><i class="fas fa-trash pointer" @click="removeFilterList(item)"></i></span>
						</div>
					</div>
				</div>
				<div class="instruction"></div>

				<div class="settings-group">
					<p>Add a department / category...</p>
					<label>Department</label>
					<div class="two-columns">
						<select v-model="newDepartment" @change="getCategories()">
							<option value="">Select...</option>
							<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
						</select>
						<div>
							<button :class="['button', 'neutral', { disabled: !newDepartment }]" @click="setFilterList()">Add</button>
						</div>
					</div>
					<label>Category</label>
					<div class="two-columns">
						<select v-model="newCategory" :disabled="!newDepartment">
							<option value="">Select...</option>
							<option v-for="(category, index) in categories" :value="category.category_id">{{ category.description }}</option>
						</select>
						<div>
							<button :class="['button', 'neutral', { disabled: !newCategory }]" @click="setFilterList()">Add</button>
						</div>
					</div>
				</div>
				<div class="instruction"></div>
			</div>

			<div v-if="settingSet == 'REQUIRE_CUSTOMERS'" class="two-columns settings-columns">
				<div>
					<p>Set any departments or categories that require a customer for a POS sale.</p>
					<label>These departments and categories require a customer...</label>
					<div class="department_list">
						<div v-for="(item, index) in currentFilterList" class="department_list_item">
							<span>{{ item.description }}</span>
							<span><i class="fas fa-trash pointer" @click="removeFilterList(item)"></i></span>
						</div>
					</div>
				</div>
				<div class="instruction">TIP: you can set Require Customer for individual products<br>from the Inventory tab in the Product Management program.</div>

				<div class="settings-group">
					<p>Add a department / category...</p>
					<label>Department</label>
					<div class="two-columns">
						<select v-model="newDepartment" @change="getCategories()">
							<option value="">Select...</option>
							<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
						</select>
						<div>
							<button :class="['button', 'neutral', { disabled: !newDepartment }]" @click="setFilterList()">Add</button>
						</div>
					</div>
					<label>Category</label>
					<div class="two-columns">
						<select v-model="newCategory" :disabled="!newDepartment">
							<option value="">Select...</option>
							<option v-for="(category, index) in categories" :value="category.category_id">{{ category.description }}</option>
						</select>
						<div>
							<button :class="['button', 'neutral', { disabled: !newCategory }]" @click="setFilterList()">Add</button>
						</div>
					</div>
				</div>
				<div class="instruction"></div>
			</div>

			<div v-if="settingSet == 'REQUIRED'">
				<div class="two-columns settings-columns">
					<div class="settings-group two-columns" style="grid-template-columns: 1fr 1fr 5em; align-items: bottom;">
						<div>
							<label>Custom Field</label>
							<select v-model="addCustomField.custom_field_id">
								<option value="">Select...</option>
								<option v-for="(customField, index) in settings.custom_fields" :value="customField.custom_field_id">{{ customField.description }}</option>
							</select>
						</div>
						<div>
							<label>Product Type</label>
							<select v-model="addCustomField.product_type_id">
								<option value="">Select...</option>
								<option v-for="(productType, index) in settings.product_types" :value="productType.product_type_id">{{ productType.description }}</option>
							</select>
						</div>
						<div>
							<label><br></label>
							<div :class="['button', addCustomField.custom_field_id ? 'action' : 'disabled']" @click="doAddCustomField()"><i class="fas fa-plus"></i></div>
						</div>
					</div>
					<div class="instruction">Select a custom field to require for specific product types at customer checkout.</div>
				</div>
				<div class="two-columns settings-columns">
					<div class="settings-group">
						<table class="data-list">
							<thead>
								<tr>
									<th class="list">Custom Field</th>
									<th class="list">Product Type</th>
									<th class="list center">Required</th>
									<th class="list right"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(customField, index) in settings.custom_field_groups">
									<td class="list">{{ customField.custom_field }}</td>
									<td class="list">{{ customField.product_type || 'Any Product Type' }}</td>
									<td class="list center">
										<input type="checkbox" v-model="customField.required" />
									</td>
									<td class="list right"><div class="button delete" @click="doRemoveCustomField(customField)"><i class="fas fa-times"></i></div></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="settings.custom_field_groups.length > 0" class="instruction">
						<p>Would you like to duplicate these settings for Website Checkout?</p>
						<div class="button neutral" @click="duplciateCustomFieldSettings()">Duplciate</div>
					</div>
				</div>
			</div>

			<div class="controls detail-controls" style="text-align: left;">
				<button class="button primary" @click="saveSettings()"><span><i class="fa fa-check"></i> Save {{ settingTitles[settingSet] }}</span></button>
			</div>

		</div>

        <loading v-else></loading>
	</div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{21:'POS Settings', 370:'Receipt', 371:'Payments', 372:'UPCs & Notifications', 373:'Commissions', 374:'Require Customer', 365:'Required Info'}" :tours="false"></help-popup>

</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import NumberInput from '@/components/NumberInput.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'settings',
	props: ['setting'],
    components: {
        'vue-dropzone': vue2Dropzone,
		'number-input': NumberInput,
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			settingTitles: {
				'RECEIPT': 'Receipt Settings',
				'PAYMENTS': 'Payment Settings',
				'UPCS': 'Special UPCs & Notifications',
				'COMMISSIONS': 'Commission Preferences',
				'REQUIRE_CUSTOMERS': 'Require Customer',
				'REQUIRED': 'Required Info'
			},
			addCustomField: {
				custom_field_id: '',
				product_type_id: ''
			},
			settingSet: '',
			settings: {},
			paymentProcessors: [],
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			clientId: '',
			departments: [],
			categories: [],
			newDepartment: '',
			newCategory: '',
			currentFilterList: []
		}
	},
	created() {
		this.fetchRouteLastRequested()
		this.settingSet = this.setting ? this.setting.toUpperCase() : 'RECEIPT'
		this.getSettings()
	},
	watch: {
		settingSet: function(which) {
			this.getSettings()
		}
	},
	computed: {
		paymentProcessorCode() {
			if (!this.settings.payment_processors || !this.settings.payment_processor_id) { return '' }
			return this.settings.payment_processors.filter(obj => obj.payment_processor_id == this.settings.payment_processor_id)[0]['payment_processor_code']
		},
		paymentProcessorName() {
			if (!this.settings.payment_processors || !this.settings.payment_processor_id) { return '' }
			return this.settings.payment_processors.filter(obj => obj.payment_processor_id == this.settings.payment_processor_id)[0]['description']
		},
		logoDropzoneOptions() {
			return {
				url: this.getApiEndpoint + '?action=upload_pos_logo',
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 1.0,
				addRemoveLinks: true,
				acceptedFiles: 'image/*',
				dictDefaultMessage: 'Drop a logo file here',
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'POS',
					context: 'LOGO',
					variation: 'large',
					image_id: this.settings.pos_store_logo || ''
				}
			}
		}
	},
	methods: {
		getSettings() {
			if (this.loading) { return }
            this.loading = true
			this.settings = {}
			this.message = ''
			this.currentFilterList = []
			this.apiCall({ destination: 'get_item_pos_settings', data: { section: this.settingSet } }).then(obj => {
                this.loading = false
				this.settings = obj.settings
				if (this.settingSet == 'COMMISSIONS') {
					if (this.settings.cashier_report_filter) {
						this.currentFilterList = this.settings.cashier_report_filter
					}
				}
				if (this.settingSet == 'REQUIRE_CUSTOMERS') {
					if (this.settings.require_customers_filter) {
						this.currentFilterList = this.settings.require_customers_filter
					}
				}
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		toggleSettings(which) {
			if (which != this.settingSet) {
				this.settingSet = which
				if ((this.settingSet == 'COMMISSIONS' || this.settingSet == 'REQUIRE_CUSTOMERS') && this.departments.length == 0) {
					this.getDepartments()
				}
			}
		},
		getDepartments() {
			this.apiCall({ destination: 'get_list_departments' }).then(obj => {
				this.departments = obj.departments
			}).catch(err => {
				console.log(err)
			})
		},
		getCategories() {
			if (this.newDepartment) {
				this.apiCall({ destination: 'get_list_categories', data: { department_id: this.newDepartment } }).then(obj => {
					this.categories = obj.categories
				}).catch(err => {
					console.log(err)
				})
			} else {
				this.newCategory = ''
				this.categories = []
			}
		},
		setFilterList() {
			if (!this.newDepartment) { return }
			let newFilterElement = {}
			this.departments.forEach((element, index) => {
				if (this.newDepartment == element.department_id) {
					newFilterElement.department_id = element.department_id
					newFilterElement.description = element.description
					return
				}
		 	})
			if (this.newCategory) {
				this.categories.forEach((element, index) => {
					if (this.newCategory == element.category_id) {
						newFilterElement.category_id = element.category_id
						newFilterElement.description += ' > ' + element.description
						return
					}
			 	})
			}
			let alreadyInList = false
			this.currentFilterList.forEach((element, index) => {
				if (element.description == newFilterElement.description) {
					alreadyInList = true
					return
				}
			})
			if (!alreadyInList) {
				this.currentFilterList.push(newFilterElement)
			}
			if (this.settingSet == 'COMMISSIONS') {
				this.settings.cashier_report_filter = this.currentFilterList
			}
			if (this.settingSet == 'REQUIRE_CUSTOMERS') {
				this.settings.require_customers_filter = this.currentFilterList
			}
		},
		removeFilterList(removeItem) {
			this.currentFilterList.forEach((element, index) => {
				if (element.description == removeItem.description) {
					this.currentFilterList.splice(index, 1);
					return
				}
			})
		},
		doAddCustomField() {
			if (!this.addCustomField.custom_field_id && !this.addCustomField.product_type_id) { return }
			let alreadyInList = false
			this.settings.custom_field_groups.forEach((element, index) => {
				if (element.custom_field_id == this.addCustomField.custom_field_id && element.product_type_id == this.addCustomField.product_type_id) {
					alreadyInList = true
					return
				}
			})
			if (alreadyInList) {
				return
			}
			let addObject = {}
			this.settings.custom_fields.forEach((element, index) => {
				if (element.custom_field_id == this.addCustomField.custom_field_id) {
					addObject.custom_field_id = element.custom_field_id
					addObject.custom_field = element.description
				}
		 	})
			this.settings.product_types.forEach((element, index) => {
				if (element.product_type_id == this.addCustomField.product_type_id) {
					addObject.product_type_id = element.product_type_id
					addObject.product_type = element.description
				}
		 	})
			addObject.required = 1
			this.settings.custom_field_groups.push(addObject)
			if (!addObject.product_type_id) {
				// if adding without a specific product_type, are there any for this field in the list with a product_type?
				let removeIndexes = []
				this.settings.custom_field_groups.forEach((element, index) => {
					if (element.custom_field_id == addObject.custom_field_id && element.product_type_id) {
						removeIndexes.push(index)
					}
			 	})
				if (removeIndexes.length > 0) {
					removeIndexes.reverse()
					removeIndexes.forEach((elementIndex) => {
						this.settings.custom_field_groups.splice(elementIndex, 1)
					})
				}
			} else {
				// we are adding a specific product type, check if there is a non-specific entry
				this.settings.custom_field_groups.forEach((element, index) => {
					if (element.custom_field_id == addObject.custom_field_id && !element.product_type_id) {
						this.settings.custom_field_groups.splice(index, 1)
					}
			 	})
			}
		},
		doRemoveCustomField(customField) {
			let removeIndex = -1
			this.settings.custom_field_groups.forEach((element, index) => {
				if (element.custom_field_id == customField.custom_field_id && element.product_type_id == customField.product_type_id) {
					removeIndex = index
					return
				}
			})
			if (removeIndex > -1) {
				this.settings.custom_field_groups.splice(removeIndex, 1)
			}
		},
		duplciateCustomFieldSettings() {
			this.duplicateMessage = ''
			this.apiCall({ destination: 'save_item_custom_field_groups', data: { force_section: 'CHECKOUT', settings: this.settings } }).then(obj => {
				this.duplicateMessage = obj.message
				setTimeout(() => { this.message = '' }, 2000)
			}).catch(err => {
				console.log(err)
			})
		},
		saveSettings() {
			if (this.saving) { return }
			this.message = 'Saving POS settings...'
			this.saving = true
			let apiAction = this.settingSet == 'REQUIRED' ? 'save_item_custom_field_groups' : 'save_item_pos_settings'
			this.apiCall({ destination: apiAction, data: { section: this.settingSet, settings: this.settings } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (this.messageStatus == 'success') {
					this.message = 'POS settings saved.'
					this.messageTimeout = 2
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		logoUploadSuccess(file, response) {
			var response = JSON.parse(response)
			if (response.image && response.image.image_id) {
				this.settings.pos_store_logo = response.image.image_id
			}
			if (response.image && response.image.image_src) {
				this.settings.pos_store_logo_src = response.image.image_src
			}
			this.$refs.logoDropzone.removeAllFiles()
		},
		logoUploadError(file, message, xhr) {
			console.log('logoUploadError')
			console.log(file)
			console.log(message)
			console.log(xhr)
		}
	}
}
</script>

<style lang="scss" scoped>
.settings-columns {
	align-items: center;
	grid-template-columns: 2fr 1fr;
	border-bottom: 1px dotted #ccc;
	margin: 0 0 1em 0;
}
.settings-columns:last-of-type {
	border-bottom: 0 none;
}
.department_list {
	min-height: 10em;
	border: 1px solid #ccc;
	padding: 0.5em;
	.department_list_item {
		display: grid;
		grid-template-columns: 1fr 2em;
		align-items: center;
		padding: 0.25em 0;
		border-bottom: 1px dotted #ccc;
	}
	.department_list_item:last-of-type {
		border-bottom: 0 none;
	}
}
</style>
